export default "__VITE_ASSET__CQgRSXhX__"